// Use Object.freeze() to make the array immutable
export const ALLOWED_UIDS = Object.freeze([
  'SSL1023',
  'FAB3680',
  'SSL0042',
  'SSL1035',
  'FAB0100',
  'FAB3647',
  'SSL1278',
  'SSL1289',
  'FAB3811',
  'FAB3615',
  'SSL0026',
  'SSL0005',
])
